// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-font[data-v-454eaaf1]{font-size:1rem;white-space:nowrap}", "",{"version":3,"sources":["webpack://./resources/js/views/index.vue"],"names":[],"mappings":"AACI,8BAEI,cAAA,CADA,kBACA","sourcesContent":["\r\n    .button-font {\r\n        white-space:nowrap;\r\n        font-size:1rem;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
